// extracted by mini-css-extract-plugin
export default {"background":"modal-overlay_background__4GWML"};